import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { Partner, ImageDescription, PartnerPageVersion } from '@fitscovery/partner/data-access';

@Component({
  selector: 'fitscovery-feature-groove-template',
  templateUrl: './feature-groove-template.component.html',
  styleUrls: ['./feature-groove-template.component.scss', '../ui/partner-homepage-groove-style.scss']
})
export class FeatureGrooveTemplateComponent implements OnInit {
  @Input() partner: Partner;
  @Input() imageDescriptions: ImageDescription[];
  theme: PartnerPageVersion;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.setTheme();
  }

  setTheme(): void {
    if (this.partner) {
      this.theme = this.partner.appConfig!.homePageVer!;
      const homepage = this.document.getElementById('homepage-groove');

      if (this.theme === PartnerPageVersion.Version3Dark) {
        homepage!.classList.add('groove-template__dark');
      } else if (
        this.theme === PartnerPageVersion.Version3Light
      ) {
        homepage!.classList.add('groove-template__light');
      }
    }
  }
}
